import { ErrorMessage } from "formik";
import * as Yup from "yup";
import { ERROR_MESSAGES } from "../utils/constant";
import RegularExpressions from "./RegularExpressions";
import CamelCaseString from "../Common/CamelCaseString";

const ValidationFields = {
  fullName: Yup.string()
    .max(20, ERROR_MESSAGES.maxCharacter20)
    .required(ERROR_MESSAGES.fieldRequired),
  firstName: Yup.string()
    .matches(RegularExpressions.alphabetsOnly, ERROR_MESSAGES.nameInvalid)
    .max(15, ERROR_MESSAGES.firstNameMax)
    .min(3, ERROR_MESSAGES.firstNameMin)
    .required(ERROR_MESSAGES.firstNameRequired),
  lastName: Yup.string()
    .matches(RegularExpressions.alphabetsOnly, ERROR_MESSAGES.nameInvalid)
    .max(15, ERROR_MESSAGES.lastNameMax)
    .min(3, ERROR_MESSAGES.lastNameMin)
    .required(ERROR_MESSAGES.lastNameRequired),
  email: Yup.string()
    .email(ERROR_MESSAGES.email)
    .required(ERROR_MESSAGES.emailRequired),
  phoneNumber: Yup.string()
    .matches(RegularExpressions.phoneNumber, ERROR_MESSAGES.phoneNumber)
    .min(14, ERROR_MESSAGES.phoneNumber)
    .max(14, ERROR_MESSAGES.phoneNumber)
    .required(ERROR_MESSAGES.phoneNumberRequired),
  graduationYear: Yup.string().required(ERROR_MESSAGES.graduationYear),
  positionPlayed: Yup.string()
    .matches(RegularExpressions.alphaNumberic, ERROR_MESSAGES.positionPlayed)
    .min(5, ERROR_MESSAGES.positionPlayed)
    .required(ERROR_MESSAGES.positionPlayedRequired),
  jerseyNumber: Yup.string()
    .matches(RegularExpressions.numberOnly, ERROR_MESSAGES.jerseyNumber)
    .min(1)
    .max(3)
    .required(ERROR_MESSAGES.jerseyNumberRequired),
  instaUrl: Yup.string().matches(
    RegularExpressions.validateUrl,
    ERROR_MESSAGES.validUrl
  ),
  twitterUrl: Yup.string().matches(
    RegularExpressions.validateUrl,
    ERROR_MESSAGES.validUrl
  ),
  schoolName: Yup.string()
    .matches(RegularExpressions.alphabetsOnly, ERROR_MESSAGES.nameInvalid)
    .required(ERROR_MESSAGES.schoolNameRequired),
  schoolId: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  schoolType: Yup.string().required(ERROR_MESSAGES.schoolTypeRequired),
  address: Yup.string().required(ERROR_MESSAGES.addressRequired),
  country: Yup.string().required(ERROR_MESSAGES.countryRequired),
  state: Yup.string().required(ERROR_MESSAGES.stateRequired),
  status: Yup.string().required(ERROR_MESSAGES.statusRequired),
  plan: Yup.string().required(CamelCaseString(ERROR_MESSAGES.Plan)).nullable(),
  playLevel: Yup.string().required(ERROR_MESSAGES.playLevel),
  sport: Yup.string().required(ERROR_MESSAGES.sportRequired),
  speciality: Yup.string().required(ERROR_MESSAGES.Speciality),
  eventName: Yup.string()
    .required(ERROR_MESSAGES.eventName)
    .min(5, ERROR_MESSAGES.eventNameMin),
  playlistName: Yup.string()
    .required(ERROR_MESSAGES.playlistName)
    .min(3, ERROR_MESSAGES.playlistNameMin),
  eventType: Yup.string().required(ERROR_MESSAGES.gameType),
  eventLocation: Yup.string()
    .min(5, ERROR_MESSAGES.eventLocationMin)
    .required(ERROR_MESSAGES.eventLocation),
  eventDescription: Yup.string()
    .min(20, ERROR_MESSAGES.eventDescriptionMin)
    .required(ERROR_MESSAGES.eventDescription),
  eventDate: Yup.string().required(ERROR_MESSAGES.eventDate),
  eventTime: Yup.string().required(ERROR_MESSAGES.eventTime),
  teamName: Yup.string().required(ERROR_MESSAGES.teamName),
  newTeamName: Yup.string().when("teamName", {
    is: "null",
    then: Yup.string()
      .min(5, ERROR_MESSAGES.newTeamNameMin)
      .required(ERROR_MESSAGES.newTeamName),
    otherwise: Yup.string(),
  }),
  groupName: Yup.string()
    .max(30, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.groupName),
  note: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.note),
  amount: Yup.string()
    .matches(RegularExpressions.numberOnly, "Enter Number Only")
    .required(ERROR_MESSAGES.amount),
  paymentMethod: Yup.string().required(ERROR_MESSAGES.paymentMethod),
  paymentStatus: Yup.string().required(ERROR_MESSAGES.paymentStatus),
  validity: Yup.string().required(ERROR_MESSAGES.validity),
  invoice: Yup.string().required(ERROR_MESSAGES.invoice),
  question: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.question),
  answer: Yup.string()
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.answer),
  contactHeading: Yup.string()
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.heading),
  contactSubHeading: Yup.string()
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.subHeading),
  menuLink1: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  menuLink2: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  menuLink3: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  menuLink4: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  menuLink5: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  menuLink6: Yup.string()
    .max(15, ERROR_MESSAGES.maxCharacter)
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.headerLink),
  foterDetails: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.footerDetails),
  facebookLink: Yup.string()
    .matches(RegularExpressions.validateUrl, ERROR_MESSAGES.validUrl)
    .required(ERROR_MESSAGES.urlRequired),
  twitterLink: Yup.string()
    .matches(RegularExpressions.validateUrl, ERROR_MESSAGES.validUrl)
    .required(ERROR_MESSAGES.urlRequired),
  linkedInLink: Yup.string()
    .matches(RegularExpressions.validateUrl, ERROR_MESSAGES.validUrl)
    .required(ERROR_MESSAGES.urlRequired),
  youtubeLink: Yup.string()
    .matches(RegularExpressions.validateUrl, ERROR_MESSAGES.validUrl)
    .required(ERROR_MESSAGES.urlRequired),
  instagramLink: Yup.string()
    .matches(RegularExpressions.validateUrl, ERROR_MESSAGES.validUrl)
    .required(ERROR_MESSAGES.urlRequired),
  signUpMessage: Yup.string().max(200, ERROR_MESSAGES.maxCharacter200),
  companyTagline: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .required(ERROR_MESSAGES.fieldRequired),
  companySubTagline: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature1: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature2: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature3: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature4: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature5: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature6: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  feature7: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  integrationTitle: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .required(ERROR_MESSAGES.fieldRequired),
  integrationDetails: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  sportAnalysisTitle: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .required(ERROR_MESSAGES.fieldRequired),
  sportAnalysisDetails: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  weekTitle: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .required(ERROR_MESSAGES.fieldRequired),
  happy_Team_description: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(300, ERROR_MESSAGES.maxCharacter300)
    .required(ERROR_MESSAGES.fieldRequired),
  weekDetails: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  softwareStrengthsTitle: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(20, ERROR_MESSAGES.maxCharacter20)
    .required(ERROR_MESSAGES.fieldRequired),
  softwareStrengthsDescription: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  selectedFileName: Yup.string().required(ERROR_MESSAGES.selectFile),
  testimonialTitle: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .required(ERROR_MESSAGES.fieldRequired),
  testimonialDescription: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(200, ERROR_MESSAGES.maxCharacter200)
    .required(ERROR_MESSAGES.fieldRequired),
  testimonialCaptian: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(100, ERROR_MESSAGES.maxCharacter100)
    .required(ERROR_MESSAGES.fieldRequired),
  breakDownName: Yup.string()
    .min(3, ERROR_MESSAGES.minCharacter)
    .max(40, ERROR_MESSAGES.maxCharacter20)
    .required(ERROR_MESSAGES.fieldRequired),
  breakDownType: Yup.string().required(ERROR_MESSAGES.fieldRequired),

  possibleValue: Yup.array()
    .when("breakDownType", {
      is: "2" || 2,
      then: Yup.array().of(
        Yup.string()
          .matches(RegularExpressions.numberOnly, "Enter Number Only")
          .required("Possible Value is required")
      ),
      otherwise: Yup.array().of(
        Yup.string()
          .matches(RegularExpressions.alphabetsOnly, "Enter Alphabet Only")
          .required("Possible Value is required")
      ),
    })
    .required("At least one Possible Value is required"),
  event: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  week: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  eventType2: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  location: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  opponent: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  filterNames: Yup.array().of(Yup.string().required("Filter name is required")),
  otherTeams: Yup.array().when("event", {
    is: "off-season",
    then: Yup.array().min(1).required("Enter atleast 1 team name"),
    otherwise: Yup.array(),
  }),
  uploadvideoEvent: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  playlistName: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  uploadVideoWeek: Yup.string().when("uploadvideoEvent", {
    is: "In-Season",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string(),
  }),
  uploadVideoEventType: Yup.string().when("uploadvideoEvent", {
    is: "In-Season",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string(),
  }),
  practice: Yup.string().when("uploadvideoEvent", {
    is: "Off-Season",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string(),
  }),
  uploadVideoOffSeasonEventName: Yup.string().when("uploadvideoEvent", {
    is: "Off-Season",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string(),
  }),
  otherEventName: Yup.string().when("uploadvideoEvent", {
    is: "Other",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string(),
  }),
  conditionName: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  conditionValue: Yup.string().when("conditionName", {
    is: "===",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string()
      .matches(RegularExpressions.numberOnly, "Enter Number Only")
      .required(ERROR_MESSAGES.fieldRequired),
  }),
  filterConditionValue: Yup.string().when("conditionName", {
    is: "EqualTo",
    then: Yup.string().required(ERROR_MESSAGES.fieldRequired),
    otherwise: Yup.string()
      .matches(RegularExpressions.numberOnly, "Enter Number Only")
      .required(ERROR_MESSAGES.fieldRequired),
  }),
  shareOption: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  videoTitle: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  videoDescription: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  rtmpUrl: Yup.string().required(ERROR_MESSAGES.fieldRequired),
  id: Yup.string()
    .matches(RegularExpressions.numberOnly, "Enter Number Only")
    .required(ERROR_MESSAGES.fieldRequired),
  IPAddressOfCamera: Yup.string()
    .matches(RegularExpressions.ipAddressRegex, "Enter Valid IP Address")
    .required("Ip Address Required"),
  userName: Yup.string()
    .matches(RegularExpressions.userName, "Enter Valid Username")
    .required("Username required"),
  password: Yup.string()
    .min(7, "Atleast 7 characters required")
    .required("Password of camera required"),
  videoName: Yup.string()
    .matches(RegularExpressions.alphaNumberic, "Enter Valid Video Name")
    .required("Video Name Required"),
  captchaValue: Yup.string().required("Captcha Required"),
  loginPassword: Yup.string()
    .min(7, "At least 7 characters required")
    .max(20, "Max 20 characters are allowed")
    .required("Password Is Required"),
  columnSet: Yup.string().required("Column set name is required"),
};

export default ValidationFields;
